import React from 'react';
import { ConnectButton } from '@rainbow-me/rainbowkit';
import { Droplets } from 'lucide-react';
import humanityLogo from '../assets/humanity-protocol-logo.svg';

/**
 * Header - Navigation bar component
 *
 * Contains project logo and wallet connection button
 */
const Header: React.FC = () => {
  return (
    <nav className="fixed top-0 w-full p-3 md:p-4 flex justify-between items-center z-50 reveal">
      <div className="relative top-2 left-2 md:left-4 flex items-center gap-3">
        <img
          alt="humanity protocol"
          width="141"
          height="32"
          className="w-[140px] h-auto md:w-[170px]"
          src={humanityLogo}
        />
        <span className="px-2.5 py-1 rounded-full bg-green-500/10 border border-green-500/20 text-[10px] font-bold tracking-wider text-green-400 uppercase">
          Demo App
        </span>
      </div>
      <div className="flex items-center gap-3 md:gap-4">
        {/* Faucet Link */}
        <a
          href="https://www.alchemy.com/faucets/humanity-testnet"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-2 px-3 py-2 md:px-4 md:py-2 rounded-lg bg-primary-5/10 border border-primary-6/20 text-primary-9 hover:bg-primary-5/20 hover:border-primary-7/30 transition-all duration-200 text-sm font-medium group"
          title="Get test tokens from faucet"
        >
          <Droplets className="w-4 h-4 md:w-4 md:h-4 group-hover:scale-110 transition-transform" />
          <span className="hidden sm:inline">Faucet</span>
        </a>

        {/* Wallet Connect Button */}
        <ConnectButton
          chainStatus="icon"
          accountStatus="full"
          showBalance={false}
        />
      </div>
    </nav>
  );
};

export default Header;
